import { createSlice } from '@reduxjs/toolkit';
import { isPlatform } from '@ionic/react';

export const isIos = createSlice({
  name: 'isIos',
  initialState: false,
  reducers: {
    setStateIos: () => {
      return isPlatform('ios') && !isPlatform('mobileweb');
    },
  },
});

export default isIos.reducer;
export const { setStateIos } = isIos.actions;
